import React, { useContext } from 'react';
import { TinyColor } from '@ctrl/tinycolor';
import { css, useTheme } from '@emotion/react';
import { type RestSimpleBlurbLaCard } from '@bbkAdminUtils/api-client/rest-la-cards-types';
import { cs } from '@bbkAdminUtils/css-utils';
import CustomerHtml from '@bbkFunnel/components/customer_html/customer_html';
import { type EmotionTheme } from '@bbkFunnel/pages/theme';
import { FunnelContext } from '@bbkFunnelComponents/FunnelContext';
import { LossGridItem } from '@bbkFunnelComponents/loss/sections/grid-item';
import { LossTitle } from '@bbkFunnelComponents/loss/sections/title';
import { makeClassNameSafe } from '@bbkFunnelUtils/utils';

import './loss-simple-blurb.scss';

type Props = {
  card: RestSimpleBlurbLaCard;
  onClick?: () => void;
};

const LossSimpleBlurb: React.FC<Props> = ({
  card,
  card: {
    requires: { quote, author, position, avatar: image, title, vertical },
  },
  onClick,
}) => {
  const theme = useTheme() as EmotionTheme;
  const { isPreview } = useContext(FunnelContext);
  const positionColor = new TinyColor(theme.textColor).lighten(20);
  const horizontal = !vertical;
  const verticalImgCss = css`
    height: auto;
    width: calc(100% + 60px);
    margin: -30px -30px 10px -30px;
    @media (max-width: 480px) {
      margin: -30px -15px 10px -15px;
      width: calc(100% + 30px);
    }
  `;
  const renderedImage = image && (
    <img
      className="blurb-photo"
      srcSet={`${image} 2x`}
      alt=""
      css={vertical && verticalImgCss}
    />
  );
  return (
    <LossGridItem
      classes={cs('bbk-loss-simple-blurb', makeClassNameSafe(card.name))}
      onClick={isPreview ? onClick : () => undefined}
    >
      {vertical && renderedImage}
      <LossTitle>
        <CustomerHtml value={title} />
      </LossTitle>
      <div className="simple-blurb">
        <div className="blurb-left">
          <div className="quote">
            <CustomerHtml value={quote} />
          </div>
          <div className="author">
            <CustomerHtml value={author} />
          </div>
          <div
            className="position"
            css={{ color: positionColor.toHexString() }}
          >
            <CustomerHtml value={position} />
          </div>
        </div>
        {horizontal && <div className="blurb-right">{renderedImage}</div>}
      </div>
    </LossGridItem>
  );
};
export default LossSimpleBlurb;
